import { render, staticRenderFns } from "./BlocksView.vue?vue&type=template&id=e370c2ac&"
import script from "./BlocksView.vue?vue&type=script&lang=js&"
export * from "./BlocksView.vue?vue&type=script&lang=js&"
import style0 from "./BlocksView.vue?vue&type=style&index=0&id=e370c2ac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VCard,VDataTable,VDivider})
